// Full Audit Questions Data based on uploaded PDFs and existing templates
// This matches the CMX website audits exactly - DO NOT consolidate or simplify

export const AUDIT_QUESTIONS = {
  'daily-walkthrough': {
    name: 'Daily Walk-Thru',
    description: 'Daily Operations Excellence Walkthrough - FRONT & KITCHEN',
    sections: [
      {
        name: 'FRONT: Condiment Station + Lobby',
        items: [
          { id: 'front-1-1', question: 'Ledges free of crumbs' },
          { id: 'front-1-2', question: '5 STAR set up complete' },
          { id: 'front-1-3', question: 'Labels for Cryovac and Seasoning' },
          { id: 'front-1-4', question: 'Garbages free of debris' },
          { id: 'front-1-5', question: 'ALL tables & condiment area CLEAN' },
          { id: 'front-1-6', question: 'POP station nozzles clean' },
          { id: 'front-1-7', question: 'Juice nozzles clean' },
          { id: 'front-1-8', question: 'All boxes organized' },
        ]
      },
      {
        name: 'FRONT: Washroom + Hallway',
        items: [
          { id: 'front-2-1', question: 'Corners clean' },
          { id: 'front-2-2', question: 'Vents clean' },
          { id: 'front-2-3', question: 'Baby table clean' },
          { id: 'front-2-4', question: 'Soap stocked' },
          { id: 'front-2-5', question: 'Toilet paper stocked' },
          { id: 'front-2-6', question: 'Paper towel stocked' },
          { id: 'front-2-7', question: 'Mirror - no stains' },
          { id: 'front-2-8', question: 'Walls clean' },
          { id: 'front-2-9', question: 'Handwashing sign visible' },
          { id: 'front-2-10', question: 'Bottom of toilet clean' },
        ]
      },
      {
        name: 'FRONT: Cleaning Closet + Mop Closet',
        items: [
          { id: 'front-3-1', question: 'All chemical (Diversey) present' },
          { id: 'front-3-2', question: 'All chemical with label' },
          { id: 'front-3-3', question: 'Mop and brooms hung up' },
          { id: 'front-3-4', question: 'Closet cleaned and organized' },
        ]
      },
      {
        name: 'FRONT: Behind Counter',
        items: [
          { id: 'front-4-1', question: 'EVERYTHING goes back where it belongs' },
          { id: 'front-4-2', question: 'All items organized' },
          { id: 'front-4-3', question: 'LABELS present on all items' },
          { id: 'front-4-4', question: 'Free of any crumbs or dust' },
          { id: 'front-4-5', question: 'All wires down and organized' },
          { id: 'front-4-6', question: 'Buckets changed with labels' },
        ]
      },
      {
        name: 'KITCHEN: Cleanliness',
        items: [
          { id: 'kitchen-1-1', question: 'Floors clean and dry' },
          { id: 'kitchen-1-2', question: 'Drains clean and clear' },
          { id: 'kitchen-1-3', question: 'All equipment wiped down' },
          { id: 'kitchen-1-4', question: 'Handwash sinks stocked' },
          { id: 'kitchen-1-5', question: 'Sanitizer buckets ready (correct concentration)' },
        ]
      },
      {
        name: 'KITCHEN: Grill & Fryer Station',
        items: [
          { id: 'kitchen-2-1', question: 'Grill cleaned and at correct temperature' },
          { id: 'kitchen-2-2', question: 'Grill gap settings correct' },
          { id: 'kitchen-2-3', question: 'Fryer oil filtered' },
          { id: 'kitchen-2-4', question: 'Fryer at correct level' },
          { id: 'kitchen-2-5', question: 'Fryer cook times programmed correctly' },
          { id: 'kitchen-2-6', question: 'Oil testing procedure followed' },
        ]
      },
      {
        name: 'KITCHEN: Food Safety',
        items: [
          { id: 'kitchen-3-1', question: 'Food Facts binder available' },
          { id: 'kitchen-3-2', question: 'Foodborne illness guide present' },
          { id: 'kitchen-3-3', question: 'Food safety logs completed' },
          { id: 'kitchen-3-4', question: 'FIFO followed' },
          { id: 'kitchen-3-5', question: 'RTE chicken checklist done' },
          { id: 'kitchen-3-6', question: 'Product expiry checked' },
        ]
      },
      {
        name: 'KITCHEN: Storage & Inventory',
        items: [
          { id: 'kitchen-4-1', question: 'Walk-in cooler organized' },
          { id: 'kitchen-4-2', question: 'Thermometers calibrated in all coolers' },
          { id: 'kitchen-4-3', question: 'All items labeled with dates' },
          { id: 'kitchen-4-4', question: 'Dry storage organized' },
          { id: 'kitchen-4-5', question: 'No items on floor' },
        ]
      },
      {
        name: 'KITCHEN: Operations & Controls',
        items: [
          { id: 'kitchen-5-1', question: 'Production charts followed' },
          { id: 'kitchen-5-2', question: 'Brixing & calibration completed' },
          { id: 'kitchen-5-3', question: 'POP syrup expiry checked' },
          { id: 'kitchen-5-4', question: 'Waste tracked' },
          { id: 'kitchen-5-5', question: 'Ventilation hood and filters clean' },
        ]
      },
      {
        name: 'Documentation & Leadership',
        items: [
          { id: 'doc-1-1', question: 'Daily walkthrough documented' },
          { id: 'doc-1-2', question: 'Issues logged and reported' },
          { id: 'doc-1-3', question: 'WALK THRU shown to team in person' },
          { id: 'doc-1-4', question: 'Corrective action taken' },
          { id: 'doc-1-5', question: 'Staff coached' },
        ]
      }
    ]
  },

  'self-assessment': {
    name: 'Restaurant Self Assessment',
    description: 'Comprehensive self-evaluation covering all restaurant operations - matches CMX exactly',
    sections: [
      {
        name: 'Food Safety - Storage',
        items: [
          { id: 'sa-s1', question: 'Is all meat (including A&W Plant Based Patty products) stored solidly frozen, properly rotated and kept covered after opening?' },
          { id: 'sa-s2', question: 'Is bacon stored refrigerated with open packages covered and used by expiry date?' },
          { id: 'sa-s3', question: 'Are onion rings refrigerated, dated and stored for 3 days maximum?' },
          { id: 'sa-s4', question: 'Is onion ring batter discarded and not stored in cooler?' },
          { id: 'sa-s5', question: 'Are bread crumbs that have been used to prepare onion rings stored properly?' },
          { id: 'sa-s6', question: 'Are eggs stored in cooler used by the expiry date on case, and eggs held on the counter timed and used within 2 hours?' },
          { id: 'sa-s7', question: 'Is cheese stored properly (refrigerated, open packs sealed and dated, used within 5 days)?' },
          { id: 'sa-s8', question: 'Is poutine cheese stored refrigerated?' },
          { id: 'sa-s9', question: 'Is produce stored to standard?' },
          { id: 'sa-s10', question: 'Are fries and sweet potato fries stored frozen, freezer not overfilled and product rotated?' },
          { id: 'sa-s11', question: 'Are hash browns, sausage patties, sausage links, and chicken portions kept frozen?' },
          { id: 'sa-s12', question: 'Are turnovers stored frozen and cinnamon sugar stored in food safe, labelled containers?' },
          { id: 'sa-s13', question: 'Are buns and bread rotated and used by best before date?' },
          { id: 'sa-s14', question: 'Are english muffins thawed, dated, stored in food safe container or bag, and used within 3 days in dry storage?' },
          { id: 'sa-s15', question: 'Are pancakes stored in freezer until thawed in the cooler, then dated for 48 hours, and stored in covered food safe container or bag?' },
          { id: 'sa-s16', question: 'Are salt and seasoning stored in foodsafe, labelled containers?' },
          { id: 'sa-s17', question: 'Are tortilla wraps stored at room temperature (never frozen or refrigerated), properly rotated, and used by the best before date or within 24 hours of being stored in the tortilla holder?' },
          { id: 'sa-s18', question: 'Are Teen tops held refrigerated a maximum of 12 hours, on trays lined with wax paper?' },
          { id: 'sa-s19', question: 'Are LTO unique ingredients stored, prepped, and held to standard?' },
          { id: 'sa-s20', question: 'Are sauces and pickles on the loading table held to standard?' },
          { id: 'sa-s21', question: 'Is produce on the loading table prepared to standard?' },
          { id: 'sa-s22', question: 'Is coney sauce safely stored in coolers (reaches below 40F within 3 hours of being placed in cooler)?' },
          { id: 'sa-s23', question: 'Are grilled onions stored in cooler safely?' },
          { id: 'sa-s24', question: 'Are all products stored in freezers sealed and covered to protect from contamination?' },
          { id: 'sa-s25', question: 'Is cooler properly laid out to protect from contamination?' },
          { id: 'sa-s26', question: 'Are all dry foods stored safely?' },
          { id: 'sa-s27', question: 'Are all utensils clean, sanitized and in good condition with food contact utensils stored properly?' },
          { id: 'sa-s28', question: 'Is all food stored in Cambro food grade totes which are properly clean, sanitized and in good condition?' },
        ]
      },
      {
        name: 'Food Safety - Procedures',
        items: [
          { id: 'sa-p1', question: 'Are Product Tracking forms complete and kept on file for 2 years?' },
          { id: 'sa-p2', question: 'Are Food Safety Checklists complete, accurate and kept on file for 1 year?' },
          { id: 'sa-p3', question: 'Are all PHF (potentially hazardous foods) in cold storage held below 40F?' },
          { id: 'sa-p4', question: 'Is all PHF in coolers stored properly?' },
          { id: 'sa-p5', question: 'Are beef patties and A&W Plant Based Patties cooked to a safe internal temperature of 160F?' },
          { id: 'sa-p6', question: 'Are other grilled products cooked to a safe internal temperature of 165F?' },
          { id: 'sa-p7', question: 'Are fried chicken products cooked to a safe internal temperature of 165F?' },
          { id: 'sa-p8', question: 'Are all utensils (grill turners, tongs, forks, and grill weights) used properly to protect food from contamination and cross-contamination?' },
          { id: 'sa-p9', question: 'Are all hot PHF stored at a safe temperature above 140F, properly timed, and not held past expiry time?' },
          { id: 'sa-p10', question: 'Is produce wash completed properly?' },
          { id: 'sa-p11', question: 'Is all food received handled properly and protected from contamination and cross contamination?' },
          { id: 'sa-p12', question: 'Is all food purchased through an approved source?' },
          { id: 'sa-p13', question: 'Are Root Beer and Diet Root Beer lines sanitized at least every 6 months by Coca Cola?' },
          { id: 'sa-p14', question: 'Are milkshake machine lines checked and sanitized weekly and machine & syrup tanks clean and in good condition?' },
          { id: 'sa-p15', question: 'Are Fresh Blends concentrates stored solidly frozen, dated properly when transferred from freezer to cooler, allowed to thaw fully over 4-5 days in cooler, and freezer pull date entered when inserted into Freshblender machine?' },
          { id: 'sa-p16', question: 'Is the Fresh Blends Clean and Safe program followed?' },
          { id: 'sa-p17', question: 'Are Fresh Blends blades replaced every 18,000 drink blending cycles?' },
          { id: 'sa-p18', question: 'Are daily and weekly cleaning procedures for Franke machine completed properly?' },
          { id: 'sa-p19', question: 'Are Franke products stored, dated, and refilled properly?' },
          { id: 'sa-p20', question: 'Is all reusable serviceware in use (mugs, baskets, plates, bowls, cutlery) free of damage?' },
          { id: 'sa-p21', question: 'Are all hand washing stations functional, draining properly, and adequately stocked with soap and single-use towels with hand washing guide posted?' },
          { id: 'sa-p22', question: 'Is the hot water meeting minimum temperature requirements?' },
          { id: 'sa-p23', question: 'Is pest control in place with no evidence of pests?' },
          { id: 'sa-p24', question: 'Is manual dishwashing completed properly using the approved 2, 3 or 5 sink method?' },
          { id: 'sa-p25', question: 'Are proper cloth management procedures in place?' },
          { id: 'sa-p26', question: 'Are all team members washing their hands after touching raw protein, after breaks, after using the washroom and following the correct procedure?' },
          { id: 'sa-p27', question: 'Are all employees in good health (not exhibiting symptoms of illness) with sores and wounds covered?' },
          { id: 'sa-p28', question: 'Are employee guidelines for gum, employee drinks, and storage of personal effects being followed?' },
          { id: 'sa-p29', question: 'Are all team members in kitchen taking proper hair control measures?' },
          { id: 'sa-p30', question: 'Are all chemicals stored away from food and packaging?' },
          { id: 'sa-p31', question: 'Are all chemical containers (including spray bottles) properly labelled to identify the chemicals they hold?' },
          { id: 'sa-p32', question: 'Is approved Atkins 3-probe thermometer available, calibrated, equipped with 3 probes and in proper working order?' },
          { id: 'sa-p33', question: 'Is a portion scale capable of measuring partial ounces available, clean, and in proper working condition?' },
          { id: 'sa-p34', question: 'Are all coolers and freezers equipped with an external thermometer in proper working condition?' },
          { id: 'sa-p35', question: 'Is all food and packaging stored a minimum of 6 inches off the floor?' },
          { id: 'sa-p36', question: 'Is all packaging used to serve food stored upside down?' },
          { id: 'sa-p37', question: 'Is all cutlery stored so it can be grabbed by the handle?' },
          { id: 'sa-p38', question: 'Are mops and brooms hung up when not in use and cleaning brushes stored away from food contact utensils with bristles up to allow drying?' },
          { id: 'sa-p39', question: 'Are current food facts available, and are management and front team members familiar with and properly following procedures for handling requests for food facts?' },
          { id: 'sa-p40', question: 'Are management and front team members familiar with and properly following procedures for handling reports of food borne illness?' },
          { id: 'sa-p41', question: 'Are Food Safety Certifications available and current per local health authority?' },
          { id: 'sa-p42', question: 'Are PHF (potentially hazardous foods) cooled to below 40F within 3 hours and reheated to 140F within 1 hour?' },
          { id: 'sa-p43', question: 'Are all food contact surfaces clean, in good condition and properly sanitized?' },
        ]
      },
      {
        name: 'Food Safety - Equipment',
        items: [
          { id: 'sa-eq1', question: 'Are onion slicers clean, sanitized and in good condition?' },
          { id: 'sa-eq2', question: 'Is tomato slicer clean, sanitized and in good condition?' },
          { id: 'sa-eq3', question: 'Is high temperature dishwasher clean, achieving dish temperatures of at least 160F, and min/max thermometer used weekly?' },
          { id: 'sa-eq4', question: 'Is low temperature dishwasher clean and rinsing with a chlorine sanitizer (D44) at a concentration of 100 ppm?' },
          { id: 'sa-eq5', question: 'Is mugwasher clean and rinsing with a chlorine sanitizer (D44) at a concentration of 100 ppm?' },
          { id: 'sa-eq6', question: 'Are pre-filters and water filters approved spec, clean, in good condition and within the 12 month expiry period?' },
          { id: 'sa-eq7', question: 'Are smallwares including onion ring sieve clean and in good condition?' },
          { id: 'sa-eq8', question: 'Are all reach-in, undercounter, and walk-in coolers and freezers clean and in good working condition?' },
          { id: 'sa-eq9', question: 'Are hoses draining into floor drains at least 2 inches above the top of the drain?' },
          { id: 'sa-eq10', question: 'Are hoses attached to faucets not submerged or fitted with back flow prevention?' },
          { id: 'sa-eq11', question: 'Is private well water tested at least twice annually and results within acceptable ranges?' },
          { id: 'sa-eq12', question: 'Are fryer baskets and skimmers completely free of damage?' },
        ]
      },
      {
        name: 'Food Quality - Cooking (Flattop)',
        items: [
          { id: 'sa-ft1', question: 'Does this restaurant use a clamshell grill?' },
          { id: 'sa-ft2', question: 'Flattop: Are all cooking and holding procedures for regular patties (3 oz) to standard?' },
          { id: 'sa-ft3', question: 'Flattop: Are all cooking and holding procedures for small patties (1.6 oz) to standard?' },
          { id: 'sa-ft4', question: 'Flattop: Are all cooking and holding procedures for large patties (5 oz) to standard?' },
          { id: 'sa-ft5', question: 'Flattop: Are all cooking and holding procedures for A&W plant-based patties to standard?' },
          { id: 'sa-ft6', question: 'Flattop: Are all cooking and holding procedures for sausage patties to standard?' },
        ]
      },
      {
        name: 'Food Quality - Cooking (Clamshell)',
        items: [
          { id: 'sa-cs1', question: 'Clamshell: Are clamshell grill programming settings updated to the most recent version?' },
          { id: 'sa-cs2', question: 'Clamshell: Are all cooking and holding procedures for regular patties (3 oz) to standard?' },
          { id: 'sa-cs3', question: 'Clamshell: Are all cooking and holding procedures for small patties (1.6 oz) to standard?' },
          { id: 'sa-cs4', question: 'Clamshell: Are all cooking and holding procedures for large patties (5 oz) to standard?' },
          { id: 'sa-cs5', question: 'Clamshell: Are all cooking and holding procedures for A&W plant-based patties to standard?' },
          { id: 'sa-cs6', question: 'Clamshell: Are all cooking and holding procedures for sausage patties to standard?' },
        ]
      },
      {
        name: 'Food Quality - Eggs, Bacon & Other',
        items: [
          { id: 'sa-eb1', question: 'Are all cooking and holding procedures for eggs to standard?' },
          { id: 'sa-eb2', question: 'Are all cooking and holding procedures for bacon to standard?' },
          { id: 'sa-eb3', question: 'Are all cooking and holding procedures for chicken to standard?' },
          { id: 'sa-eb4', question: 'Are all cooking and holding procedures for onion rings to standard?' },
          { id: 'sa-eb5', question: 'Are fries cooked to standard with proper cook times, oil temperature, and portioning?' },
          { id: 'sa-eb6', question: 'Are sweet potato fries cooked to standard?' },
          { id: 'sa-eb7', question: 'Are all bun toasting and holding procedures to standard?' },
          { id: 'sa-eb8', question: 'Are all holding times followed and expired product discarded?' },
        ]
      },
      {
        name: 'Clean & Tidy - Exterior',
        items: [
          { id: 'sa-ex1', question: 'Are building exterior walls, doors, bollard covers and stairs clean, well-maintained and in good repair?' },
          { id: 'sa-ex2', question: 'Are parking lot and landscaped areas clean, free of litter, weeds and well maintained?' },
          { id: 'sa-ex3', question: 'Is the Exterior Maintenance Checklist completed in CMX three times per year (Spring, Summer, Fall/Winter)?' },
          { id: 'sa-ex4', question: 'Is the drive thru lane from the entrance to the exit, including driveway, menuboard, OCB and window, clean and in good repair?' },
          { id: 'sa-ex5', question: 'Are all illuminated signs and menuboards (exterior and interior) fully lit?' },
        ]
      },
      {
        name: 'Clean & Tidy - Team Appearance',
        items: [
          { id: 'sa-ta1', question: 'Is Uniform Poster current and posted for employees reference?' },
          { id: 'sa-ta2', question: 'Are all team members to standard on grooming and hair control?' },
          { id: 'sa-ta3', question: 'Are all team members outfitted in A&W issue shirts, sweaters, and jackets which are clean, wrinkle-free, and in good condition?' },
          { id: 'sa-ta4', question: 'Are name tags worn to standard?' },
          { id: 'sa-ta5', question: 'Are all team members wearing dark blue denim jeans or black dress pants which are clean, wrinkle-free, and in good condition with belts worn to standard?' },
          { id: 'sa-ta6', question: 'Are all team members wearing aprons to standard?' },
          { id: 'sa-ta7', question: 'Are all team members wearing footwear, socks and hosiery to standard?' },
        ]
      },
      {
        name: 'Clean & Tidy - Servery & Dining Room',
        items: [
          { id: 'sa-sd1', question: 'Is the Be Clean program in place and activities completed in CMX as scheduled?' },
          { id: 'sa-sd2', question: 'Are the cup dispensers clean and in good condition?' },
          { id: 'sa-sd3', question: 'Is all permanent interior signage (menuboards, wood panel, magnetic POS, firelight signs, wall plaques) posted, clean, in excellent condition, functioning properly, approved and current?' },
          { id: 'sa-sd4', question: 'Is the front room counter clean, clutter free and in good condition?' },
          { id: 'sa-sd5', question: 'Are dining room walls, floors, ceiling tiles, and entrance ways clean and in good repair with all lights working?' },
          { id: 'sa-sd6', question: 'Are all windows clean, with frames in good condition and are blinds clean and in good working condition?' },
          { id: 'sa-sd7', question: 'Is dining room well maintained?' },
          { id: 'sa-sd8', question: 'Are tables, chairs, booths and high chairs in good condition?' },
          { id: 'sa-sd9', question: 'Are front room walls and lights clean and in good condition with all lights working?' },
          { id: 'sa-sd10', question: 'Are condiment stations clean, maintained and in good repair?' },
          { id: 'sa-sd11', question: 'Are bussing stations clean, maintained and in good repair?' },
          { id: 'sa-sd12', question: 'Is self-serve pop station clean, stocked, and in good repair?' },
          { id: 'sa-sd13', question: 'Is hand sanitizer readily available for guests?' },
        ]
      },
      {
        name: 'Clean & Tidy - Washrooms',
        items: [
          { id: 'sa-wr1', question: 'Are all washrooms, including staff washroom, fully stocked with soap, paper towels, toilet paper, and garbage not overflowing?' },
          { id: 'sa-wr2', question: 'Are all fixtures (sinks, hand dryers, toilets, urinals) clean, functioning properly, and to standard in both staff and guest washrooms?' },
          { id: 'sa-wr3', question: 'Are all walls, doors, and partitions clean and in good condition with no graffiti in both staff and guest washrooms?' },
          { id: 'sa-wr4', question: 'Are all mirrors clean and not scratched in both staff and guest washrooms?' },
          { id: 'sa-wr5', question: 'Are all stall door locks in guest washrooms working properly?' },
          { id: 'sa-wr6', question: 'Are all washrooms, including staff washroom, free of unpleasant odour?' },
          { id: 'sa-wr7', question: 'Are all ceilings, ceiling vents, and lighting clean and in good repair in both staff and guest washrooms?' },
          { id: 'sa-wr8', question: 'Are floors and baseboards clean and in good repair with wet floor signs used correctly in both staff and guest washrooms?' },
          { id: 'sa-wr9', question: 'Are all washroom counters, garbage cans, coat hooks, change tables, and hand rails clean, available as required, secure, and in good repair?' },
        ]
      },
      {
        name: 'Clean & Tidy - Kitchen',
        items: [
          { id: 'sa-kt1', question: 'Are exhaust hoods and filters clean and in good condition with ducts cleaned every 6 months?' },
          { id: 'sa-kt2', question: 'Are all kitchen floors, baseboards, walls, shelves and doors clean and in good condition?' },
          { id: 'sa-kt3', question: 'Are all kitchen ceilings, vents, and lighting clean and in good condition with light fixtures working properly?' },
          { id: 'sa-kt4', question: 'Are all kitchen garbage containers clean and in good condition?' },
          { id: 'sa-kt5', question: 'Are all kitchen sinks, grease traps, and mop & bucket clean and in good repair?' },
          { id: 'sa-kt6', question: 'Are all kitchen counters and tables clean and in good food safe condition?' },
          { id: 'sa-kt7', question: 'Are all kitchen storage and office areas clean and in good repair?' },
        ]
      },
      {
        name: 'People - Working Environment',
        items: [
          { id: 'sa-we1', question: 'Is fire suppression serviced on schedule?' },
          { id: 'sa-we2', question: 'Is HVAC (heating, ventilation and air conditioning) in good working order?' },
          { id: 'sa-we3', question: 'If available, is microwave clean, in good condition, and used ONLY to satisfy guest requests or to heat staff meals?' },
          { id: 'sa-we4', question: 'Are timers, fryers, Cvap doors and other equipment properly labelled?' },
          { id: 'sa-we5', question: 'Are Temporary Foreign Worker Program regulations in compliance?' },
        ]
      },
      {
        name: 'People - Climate & Training',
        items: [
          { id: 'sa-cl1', question: 'Were 2 proper Climate meetings held within the last year with restaurant staff?' },
          { id: 'sa-cl2', question: 'Have all supervisory staff completed the full Leadership Through Climate (RMTP) learning cycle within 60 days of assuming a supervisor role?' },
          { id: 'sa-cl3', question: 'Have all new employees completed New Employee Training Orientation course?' },
          { id: 'sa-cl4', question: 'Have all trainers completed "Train the Trainer" course?' },
          { id: 'sa-cl5', question: 'Can employees describe when they would need a SDS and where they are stored?' },
          { id: 'sa-cl6', question: 'Was a Restaurant Self-Assessment completed in each of the last 4 quarters?' },
          { id: 'sa-cl7', question: 'Have all employees on shift completed online training modules for stations they are working?' },
        ]
      },
      {
        name: 'Service & Speed - Service Times',
        items: [
          { id: 'sa-st1', question: 'Is the parking procedure followed?' },
          { id: 'sa-st2', question: 'Are orders bumped only when all hot food is in the chute/staging area?' },
          { id: 'sa-st3', question: 'Average all-day (6:00am-11:00pm) Drive Thru service times from prior 4 full weeks within standard (80 seconds)?' },
          { id: 'sa-st4', question: 'Average all-day (6:00am-11:00pm) Counter service times from prior 4 full weeks within standard (150-200 seconds)?' },
        ]
      },
      {
        name: 'Service & Speed - Operating System Execution',
        items: [
          { id: 'sa-os1', question: 'Are guests the first priority for the team, attended to immediately upon arrival at drive thru and acknowledged and attended to immediately at the counter?' },
          { id: 'sa-os2', question: 'Are team members aware of and actively engaged in creating GEMs in the restaurant?' },
          { id: 'sa-os3', question: 'Is every guest prompted for A&W Rewards?' },
          { id: 'sa-os4', question: 'Did the cashier offer a combo when appropriate?' },
          { id: 'sa-os5', question: 'Did the cashier display menu knowledge?' },
          { id: 'sa-os6', question: 'Was payment processed properly?' },
          { id: 'sa-os7', question: 'Was transaction completed properly?' },
          { id: 'sa-os8', question: 'Is the Cleanstix (or equivalent) pinpad extender being used at drive thru?' },
          { id: 'sa-os9', question: 'Is the Daily Ops Excellence Chart current and posted where it is visible to all team members?' },
          { id: 'sa-os10', question: 'Is a designated cashier ready to serve guests and are guests acknowledged immediately?' },
          { id: 'sa-os11', question: 'Are sales forecasts completed weekly and corrective actions taken when necessary?' },
          { id: 'sa-os12', question: 'Are grill and fryer production charts posted, current, and being followed?' },
          { id: 'sa-os13', question: 'Is the Fast 5 system in place per the positioning charts?' },
          { id: 'sa-os14', question: 'Are enough team members scheduled to delight guests?' },
          { id: 'sa-os15', question: 'Are team members hustling and serving guests as their first priority based on the roles and responsibilities chart?' },
          { id: 'sa-os16', question: 'Are procedures for preparing and serving Brew Bar beverages followed?' },
          { id: 'sa-os17', question: 'Is prepared food (except turnovers) placed in chute/staging area only after it has been ordered by a guest?' },
          { id: 'sa-os18', question: 'Are drive thru guests greeted immediately upon arrival and order taken immediately if guest is ready?' },
          { id: 'sa-os19', question: 'Are guests greeted immediately upon arriving at the drive thru window?' },
          { id: 'sa-os20', question: 'Are drive thru drinks poured by the order taker as soon as they are ordered?' },
          { id: 'sa-os21', question: 'Are team members in all appropriate positions wearing head sets?' },
          { id: 'sa-os22', question: 'Is the drive thru drink fountain calibrated properly for flow rates and paper cup fill levels?' },
          { id: 'sa-os23', question: 'Is drive thru work area well organized and free of clutter?' },
          { id: 'sa-os24', question: 'Are all orders for takeout and drive thru correctly packaged?' },
          { id: 'sa-os25', question: 'Are third-party and mobile delivery procedures followed for every delivery order?' },
          { id: 'sa-os26', question: 'Are Mobile App order fulfillment procedures followed for every mobile order?' },
          { id: 'sa-os27', question: 'Is Advanced Station Training (AST) completed for the runner and point people working today?' },
          { id: 'sa-os28', question: 'Is complete POS system clean and in proper working order?' },
          { id: 'sa-os29', question: 'Are microphone, head sets and order confirmation board clean and in proper working order?' },
          { id: 'sa-os30', question: 'Are teen tops prepared and held to standard?' },
        ]
      },
      {
        name: 'Brand Standards',
        items: [
          { id: 'sa-bs1', question: 'Are all menu items available and prepared to recipe?' },
          { id: 'sa-bs2', question: 'Are all and only required food ingredients available?' },
          { id: 'sa-bs3', question: 'Are all and only required packaging items available?' },
          { id: 'sa-bs4', question: 'Are all sizes of glass mugs and coffee mugs available?' },
          { id: 'sa-bs5', question: 'Is all required equipment available and to standard?' },
          { id: 'sa-bs6', question: 'Is only approved menuboard in use and arranged to standard on Xchange?' },
          { id: 'sa-bs7', question: 'Are only approved cleaning products in use and properly labelled with accompanying SDS available?' },
          { id: 'sa-bs8', question: 'Are only approved promotional or premium items available for sale?' },
          { id: 'sa-bs9', question: 'Is the restaurant participating in all NAAC mandated promotions?' },
          { id: 'sa-bs10', question: 'Is all POS current and consistent with NAAC requirements?' },
          { id: 'sa-bs11', question: 'Are trademarks used properly in local marketing (including billboards)?' },
          { id: 'sa-bs12', question: 'Is the restaurant current with modernization requirements, including all building and lot signage?' },
          { id: 'sa-bs13', question: 'Does the restaurant sell and redeem A&W gift cards (including mobile redemptions)?' },
          { id: 'sa-bs14', question: 'Is the WiFi service provided by the approved Internet Service Provider (ISP)?' },
          { id: 'sa-bs15', question: 'Are all team members outfitted in the current uniform?' },
          { id: 'sa-bs16', question: 'Are the restaurant hours posted on the Xchange, Google, and the A&W Mobile App accurate and competitive?' },
        ]
      }
    ]
  },

  'bca': {
    name: 'Brand Compliance Assessment (BCA)',
    description: 'A&W Brand Compliance Assessment - Full evaluation of brand standards from CMX',
    sections: [
      {
        name: '5 Star Operating System',
        items: [
          { id: 'bca-5s1', question: 'Are roles and responsibilities assigned and followed per the appropriate positioning chart?' },
          { id: 'bca-5s2', question: 'Are 5 STAR Phase 1 counter flow procedures followed by Guest Experience team members?' },
          { id: 'bca-5s3', question: 'Are 5 STAR Phase 1 drive thru procedures followed by Guest Experience team members?' },
          { id: 'bca-5s4', question: 'Are 5 STAR Phase 1 production procedures followed by Production Team members?' },
          { id: 'bca-5s5', question: 'Are production charts posted, easily visible, and accurate?' },
          { id: 'bca-5s6', question: 'Are 5 STAR Phase 1 employee communication elements posted and filled in with current information?' },
          { id: 'bca-5s7', question: 'Is the Be Clean Program followed and all daily, weekly, and monthly activities completed on time in CMX?' },
        ]
      },
      {
        name: 'Service & Speed',
        items: [
          { id: 'bca-ss1', question: 'Was the greeting prompt, polite and welcoming?' },
          { id: 'bca-ss2', question: "Was the team member attitude 'happy to be serving you'?" },
          { id: 'bca-ss3', question: 'Did the cashier display menu knowledge?' },
          { id: 'bca-ss4', question: 'Was payment processed properly?' },
          { id: 'bca-ss5', question: 'Was transaction completed properly?' },
          { id: 'bca-ss6', question: 'Are orders bumped only when all hot food is in the chute/staging area?' },
          { id: 'bca-ss7', question: 'Is the parking procedure followed?' },
          { id: 'bca-ss8', question: 'Is the Cleanstix (or equivalent) pinpad extender being used at drive thru for debit and credit transactions?' },
          { id: 'bca-ss9', question: 'Average all-day Drive Thru service times from prior 4 full weeks within standard (80 seconds)?' },
          { id: 'bca-ss10', question: 'Average all-day Counter service times from prior 4 full weeks within standard (150-200 seconds)?' },
          { id: 'bca-ss11', question: 'Are A&W Rewards procedures followed for every order?' },
        ]
      },
      {
        name: 'Clean & Tidy',
        items: [
          { id: 'bca-ct1', question: 'Are washrooms (including staff washrooms where applicable) open, spotlessly clean and in good repair?' },
          { id: 'bca-ct2', question: 'Are all team members in proper, clean uniform and well groomed?' },
          { id: 'bca-ct3', question: 'Are dining room walls, floors, ceiling tiles, and entrance ways clean and in good repair with all lights working?' },
          { id: 'bca-ct4', question: 'Is dining room well maintained?' },
          { id: 'bca-ct5', question: 'Is the front room counter free of clutter, clean and in good condition?' },
          { id: 'bca-ct6', question: 'Are front room walls, floors, ceiling/bulkhead, and lights clean, in good condition and all lights working?' },
          { id: 'bca-ct7', question: 'Are condiment, bussing, and self-serve pop stations clean, maintained, and in good repair?' },
          { id: 'bca-ct8', question: 'Is music from approved supplier, set to appropriate station and at appropriate volume?' },
          { id: 'bca-ct9', question: 'Is all permanent signage (logos, menuboards, boomerangs, OCB, readerboard, attribute posters, window clings, wood panel, magnetic POS, wall plaques) posted, clean, in excellent condition, functioning properly, fully lit, approved and current?' },
          { id: 'bca-ct10', question: 'Are exterior walls, windows, doors, bollard covers, and stairs clean and in good repair?' },
          { id: 'bca-ct11', question: 'Are exterior garbage cans and enclosures clean, in good repair and not overflowing?' },
          { id: 'bca-ct12', question: 'Are parking lot, patio and landscaped areas clean, free of litter and inviting?' },
          { id: 'bca-ct13', question: 'Is the drive thru lane from the entrance to the exit (including driveway and window) clean and in good repair?' },
          { id: 'bca-ct14', question: 'Were 3 Exterior Maintenance Checklists completed within the last year, spaced out appropriately for spring, summer, and fall/winter?' },
        ]
      },
      {
        name: 'Food Quality',
        items: [
          { id: 'bca-fq1', question: 'Was the order accurate?' },
          { id: 'bca-fq2', question: 'Was the burger/egger/bacon and eggs hot and prepared properly?' },
          { id: 'bca-fq3', question: 'Was the burger/egger/bacon and eggs assembled and packaged properly?' },
          { id: 'bca-fq4', question: 'Was the side order hot and prepared to standard?' },
          { id: 'bca-fq5', question: 'Was the drink prepared to standard?' },
          { id: 'bca-fq6', question: 'Are grill cook times and gap settings programmed correctly and procedures followed?' },
          { id: 'bca-fq7', question: 'Are all grill hold times programmed correctly and procedures followed?' },
          { id: 'bca-fq8', question: 'Are all fryer cook times programmed, labelled to standard and procedures followed?' },
          { id: 'bca-fq9', question: 'Are all fryer hold times programmed correctly and procedures followed?' },
          { id: 'bca-fq10', question: 'Are all fryer sensitivity settings programmed correctly and recovery is within standard?' },
          { id: 'bca-fq11', question: 'Is approved oil testing procedure in place and oil condition to standard?' },
          { id: 'bca-fq12', question: 'Are toaster settings correct and providing the desired outcome?' },
          { id: 'bca-fq13', question: 'Are bun and onion warmer hold times correctly programmed and procedures followed?' },
          { id: 'bca-fq14', question: 'Are Thermodyne hold times correctly programmed and procedures followed?' },
          { id: 'bca-fq15', question: 'Is prepared food (except turnovers) placed in chute/staging area only after it has been ordered by a guest?' },
          { id: 'bca-fq16', question: 'Are all products on the loading table properly held and timed?' },
          { id: 'bca-fq17', question: 'Are brixing practices followed and all fountain beverages brixed correctly?' },
          { id: 'bca-fq18', question: 'Are all cold beverage serving temperatures correct?' },
          { id: 'bca-fq19', question: 'Are all hot beverage serving temperatures correct?' },
          { id: 'bca-fq20', question: 'Is Franke equipment dispensing product properly and to the appropriate fill level, and procedures followed?' },
          { id: 'bca-fq21', question: 'Is Fresh Blends equipment dispensing product properly and to the appropriate fill level, and procedures followed?' },
          { id: 'bca-fq22', question: 'Are third-party and mobile delivery procedures followed for every delivery order?' },
          { id: 'bca-fq23', question: 'Are Mobile App order fulfillment procedures followed for every mobile order?' },
        ]
      },
      {
        name: 'Food Safety',
        items: [
          { id: 'bca-fs1', question: 'Are Food Safety Checklists complete, accurate and kept on file for 1 year?' },
          { id: 'bca-fs2', question: 'Are Product Tracking forms complete and kept on file for 2 years?' },
          { id: 'bca-fs3', question: 'Are Perfect Food Checklists (Kitchen & Front) completed weekly, corrective actions taken as required, and current to the restaurant\'s menu offerings?' },
          { id: 'bca-fs4', question: 'Are Food Safety Certifications available and current per local health authority?' },
          { id: 'bca-fs5', question: 'Are all PHF (potentially hazardous foods) in cold storage held below 40F?' },
          { id: 'bca-fs6', question: 'Are all hot products stored at a minimum of 140F?' },
          { id: 'bca-fs7', question: 'Are beef products cooked to a minimum of 160F and other proteins to a minimum of 165F?' },
          { id: 'bca-fs8', question: 'Are PHF (potentially hazardous foods) cooled to below 40F within 3 hours and reheated to 140F within 1 hour?' },
          { id: 'bca-fs9', question: 'Is all food stored properly in dry storage areas (including kitchen and front room)?' },
          { id: 'bca-fs10', question: 'Is all food stored properly in coolers?' },
          { id: 'bca-fs11', question: 'Is all food stored properly in freezers?' },
          { id: 'bca-fs12', question: 'Is proper hand washing taking place and do all employees appear in good health?' },
          { id: 'bca-fs13', question: 'Is produce prep, including washing, cutting, and storage procedures, completed properly?' },
          { id: 'bca-fs14', question: 'Are cloth management and dish washing completed properly?' },
          { id: 'bca-fs15', question: 'Are all food contact surfaces clean, in good condition and properly sanitized?' },
          { id: 'bca-fs16', question: 'Are tongs and utensils correctly used to protect food from contamination?' },
          { id: 'bca-fs17', question: 'Is production area of kitchen clean and well maintained?' },
          { id: 'bca-fs18', question: 'Is storage area of kitchen clean and well maintained?' },
          { id: 'bca-fs19', question: 'Is prep / sink area of kitchen clean and well maintained?' },
          { id: 'bca-fs20', question: 'Is pest control in place with no evidence of pests?' },
          { id: 'bca-fs21', question: 'Is the Fresh Blends Clean and Safe program followed?' },
        ]
      },
      {
        name: 'Climate & Training',
        items: [
          { id: 'bca-tr1', question: 'Were 2 Climate meetings held within the last year with restaurant staff?' },
          { id: 'bca-tr2', question: 'Have all management staff completed the full Leadership Through Climate (RMTP) learning cycle within 60 days of assuming a manager role?' },
          { id: 'bca-tr3', question: 'Have all new employees completed the Team Member Training Orientation curriculum?' },
          { id: 'bca-tr4', question: 'Have all employees on shift completed online training modules for stations they are working?' },
          { id: 'bca-tr5', question: 'Have all trainers completed Train the Trainer course?' },
          { id: 'bca-tr6', question: 'Can employees describe when they would need a SDS sheet and where they are stored?' },
          { id: 'bca-tr7', question: 'Was a Restaurant Self Assessment completed in each of the last 4 quarters?' },
        ]
      },
      {
        name: 'Brand Standards',
        items: [
          { id: 'bca-bs1', question: 'Are all menu items available and prepared to recipe?' },
          { id: 'bca-bs2', question: 'Are all and only required food ingredients available?' },
          { id: 'bca-bs3', question: 'Are all and only required packaging items available?' },
          { id: 'bca-bs4', question: 'Are all sizes of glass mugs and coffee mugs available?' },
          { id: 'bca-bs5', question: 'Is all required equipment available and to standard?' },
          { id: 'bca-bs6', question: 'Is only approved menuboard in use and arranged to standard on Xchange?' },
          { id: 'bca-bs7', question: 'Are only approved cleaning products in use, properly labelled and with accompanying SDS available?' },
          { id: 'bca-bs8', question: 'Are only approved promotional or premium items available for sale?' },
          { id: 'bca-bs9', question: 'Is the restaurant participating in all NAAC mandated promotions?' },
          { id: 'bca-bs10', question: 'Is all POS current and consistent with NAAC requirements?' },
          { id: 'bca-bs11', question: 'Are trademarks used properly in local marketing (including billboards)?' },
          { id: 'bca-bs12', question: 'Is the restaurant current with modernization requirements, including all building and lot signage?' },
          { id: 'bca-bs13', question: 'Does the restaurant sell and redeem A&W gift cards (including mobile redemptions)?' },
          { id: 'bca-bs14', question: 'Is the WiFi service provided by the approved Internet Service Provider (ISP)?' },
          { id: 'bca-bs15', question: 'Are all team members outfitted in the current uniform?' },
          { id: 'bca-bs16', question: 'Are the restaurant hours posted on the Xchange, Google, and the A&W Mobile App accurate and competitive?' },
        ]
      }
    ]
  },

  'steritech': {
    name: 'Steritech Self Assessment',
    description: 'Food safety audit with Critical, Second, and Third Priority violations - matches CMX exactly',
    sections: [
      {
        name: 'Critical Priority - Cold Holding & Temperature',
        items: [
          { id: 'st-A101', question: 'A101 - Cold potentially hazardous foods are maintained at 4.0C (39.2F) or below in all cold-holding devices', critical: true },
          { id: 'st-A103', question: 'A103 - Hot potentially hazardous foods are maintained at 60.0C (140.0F) or above', critical: true },
          { id: 'st-A105', question: 'A105 - Walk-in cooler potentially hazardous foods are maintained at 4.0C (39.2F) or below', critical: true },
          { id: 'st-A107', question: 'A107 - Potentially hazardous foods held by time alone are at proper temperature before being removed from temperature control, time-stamped for no more than 2 hours, and served or discarded within 2 hours', critical: true },
          { id: 'st-A109', question: 'A109 - Potentially hazardous foods are cooked to proper internal temperatures (beef 71C/160F, poultry 74C/165F, eggs 74C/165F)', critical: true },
          { id: 'st-A111', question: 'A111 - Potentially hazardous foods are cooled from 60C to 20C within 2 hours, and from 20C to 4C within 4 hours', critical: true },
        ]
      },
      {
        name: 'Critical Priority - Food Protection & Contamination',
        items: [
          { id: 'st-A115', question: 'A115 - Foods are not contaminated. Foods and food-contact surfaces are protected from potential microbiological, physical and chemical hazards', critical: true },
          { id: 'st-A117', question: 'A117 - Foods on display at service counters are protected from contamination by sneeze guards, packaging, or other effective protection', critical: true },
          { id: 'st-A119', question: 'A119 - Potentially hazardous foods are not held or sold past expiration date', critical: true },
          { id: 'st-A121', question: 'A121 - Foods are from commercial suppliers. Foods and packaging are in sound condition', critical: true },
          { id: 'st-A123', question: 'A123 - Food-contact surfaces of equipment and utensils are non-toxic and made of safe materials', critical: true },
          { id: 'st-A125', question: 'A125 - Food-contact surfaces are properly cleaned and sanitized (at least every 4 hours during continuous use)', critical: true },
        ]
      },
      {
        name: 'Critical Priority - Chemicals & Sanitizer',
        items: [
          { id: 'st-A127', question: 'A127 - Chemical sanitizer solutions for manual use (sinks, buckets, spray bottles) are maintained at proper concentration and temperature', critical: true },
          { id: 'st-A128', question: 'A128 - Chemical sanitizer solutions for dish machines are maintained at proper concentration and temperature', critical: true },
          { id: 'st-A129', question: 'A129 - Chemicals are used correctly and only for their intended purpose. Containers previously used for chemicals are not used for food', critical: true },
        ]
      },
      {
        name: 'Critical Priority - Personal Hygiene & Safety',
        items: [
          { id: 'st-A131', question: 'A131 - Hands are washed using hot water and soap for 20 seconds and dried using disposable towels. Hands washed before donning gloves', critical: true },
          { id: 'st-A135', question: 'A135 - Persons displaying symptoms (vomiting, diarrhea, jaundice, sore throat with fever) are excluded from the establishment', critical: true },
        ]
      },
      {
        name: 'Critical Priority - Infrastructure & Pest',
        items: [
          { id: 'st-A139', question: 'A139 - Air gaps/backflow prevention devices are in place where required. Sewage disposal systems, including grease traps, are operating properly', critical: true },
          { id: 'st-A141', question: 'A141 - Potable water is available from a public water system or a properly maintained non-public system', critical: true },
          { id: 'st-A143', question: 'A143 - Pest prevention program is effective', critical: true },
        ]
      },
      {
        name: 'Critical Priority - A&W Specific',
        items: [
          { id: 'st-701', question: '701 - Raw meat grilling must not be performed on the first 2 inches of the left side of the flat top grill', critical: true },
          { id: 'st-721', question: '721 - Temperature checklists for Kitchen and Front Room available and complete', critical: true },
          { id: 'st-733', question: '733 - Restaurant has completed the Food Safety Section of the Self Assessment since last assessment', critical: true },
        ]
      },
      {
        name: 'Second Priority - Fresh Blends',
        items: [
          { id: 'st-901', question: '901 - Dispensing Head and Dispensing Area - clean, free of build-up, valves not clogged/ripped/missing' },
          { id: 'st-903', question: '903 - Blend Shaft and Blend Area - clean, free of build-up, shaft free of damage and operational' },
          { id: 'st-905', question: '905 - Fresh Blends Refrigerator - clean, door gasket free of damage, wearable valves correctly positioned, bottom tray clean' },
          { id: 'st-907', question: '907 - Required tools and chemicals are on hand for Fresh Blends (Diversol, Benefit Cleaner, shaker jugs, CIP hose, cups)' },
          { id: 'st-909', question: '909 - Fresh Blends Training - person on shift has completed required Safe & Clean training, can describe 4 Hour Blender Sanitize, Zone 1-4 procedures' },
        ]
      },
      {
        name: 'Second Priority - Thermometers & Receiving',
        items: [
          { id: 'st-B209', question: 'B209 - Thermometers are accurate and available for use in food receiving, preparation, holding and serving areas' },
          { id: 'st-B211', question: 'B211 - At receiving, foods show no signs of temperature abuse and PHF are received at proper temperatures' },
          { id: 'st-B203', question: 'B203 - Fruits and vegetables cooked for hot holding are cooked to minimum 60C (140F)' },
        ]
      },
      {
        name: 'Second Priority - Food Handling & Storage',
        items: [
          { id: 'st-B207', question: 'B207 - Proper cooling methods (shallow pans, chill blasters, cooling wands) are used for PHF' },
          { id: 'st-B213', question: 'B213 - Potentially hazardous foods are thawed under refrigeration' },
          { id: 'st-B225', question: 'B225 - Date marking is applied at time of preparation to PHF intended to be held cold more than 24 hours (shelf life max 7 days)' },
          { id: 'st-B226', question: 'B226 - Pre-packaged food for sale and bulk food are labeled with common name, ingredients, net weight, allergen info, and nutrition labeling' },
          { id: 'st-B229', question: 'B229 - Source tags for shellfish and freezing process records for fin fish are dated and held at least 90 days' },
          { id: 'st-B231', question: 'B231 - Consumer advisories are posted for raw or undercooked animal products offered as ready-to-eat' },
        ]
      },
      {
        name: 'Second Priority - Equipment & Surfaces',
        items: [
          { id: 'st-B215', question: 'B215 - Food-contact surfaces are smooth, easily cleanable, and in good condition' },
          { id: 'st-B239', question: 'B239 - Sanitizer test kits are open and readily available for use (Quat, AHP 100 Produce, Chlorine strips)' },
          { id: 'st-B235', question: 'B235 - Cleaning and maintenance tools are not cleaned in food prep sinks, dishwashing machines, or dishwashing sinks' },
          { id: 'st-B237', question: 'B237 - Manual warewashing occurs in three-compartment sink with basins large enough to immerse largest equipment' },
        ]
      },
      {
        name: 'Second Priority - Handwashing & Hygiene',
        items: [
          { id: 'st-B217', question: 'B217 - Handwashing facilities are located convenient to food handling, maintained accessible, and used only for handwashing' },
          { id: 'st-B219', question: 'B219 - Handwashing facilities maintained clean, supplied with hot water, soap, disposable towels, and signed to remind employees' },
          { id: 'st-B221', question: 'B221 - Gloves changed whenever damaged or torn. Gloves worn over bandages. Fingernails trimmed' },
          { id: 'st-B227', question: 'B227 - Live animals are not permitted in areas where food and food-contact items are used, prepared, or stored' },
        ]
      },
      {
        name: 'Second Priority - Chemicals & Documentation',
        items: [
          { id: 'st-B233', question: 'B233 - Original containers of toxic materials have legible labels. Working containers labeled with common name. Only required chemicals present' },
          { id: 'st-B241', question: 'B241 - Hot and cold water sufficient for peak demand. Plumbing provides adequate pressure. Non-public water tested annually' },
          { id: 'st-723', question: '723 - Product Tracking / Product Code form available and complete (previous 4 weeks)' },
          { id: 'st-727', question: '727 - Food safety certification available and current per provincial standards' },
          { id: 'st-735', question: '735 - The restaurant has a written sanitation program in place with daily sign-off' },
        ]
      },
      {
        name: 'Third Priority - Facility & Temperature',
        items: [
          { id: 'st-C301', question: 'C301 - Refrigerated and hot holding units have accurate, easily viewable thermometers for PHF' },
          { id: 'st-C305', question: 'C305 - Frozen foods are held solidly frozen so they are hard to the touch' },
          { id: 'st-C303', question: 'C303 - Potentially hazardous foods are thawed under refrigeration' },
        ]
      },
      {
        name: 'Third Priority - Food Protection',
        items: [
          { id: 'st-C307', question: 'C307 - Foods are properly protected from contamination. Foods in storage are properly covered unless cooling' },
          { id: 'st-C309', question: 'C309 - Fruits and vegetables are properly washed prior to processing and serving (produce wash 3-5 min soak)' },
          { id: 'st-C311', question: 'C311 - Foods are properly identified with the common name of the product on the container' },
          { id: 'st-C313', question: 'C313 - Foods and food-contact packaging are stored at least 6 inches off the floor' },
          { id: 'st-C323', question: 'C323 - In-use utensils (including ice scoops) properly handled and stored. Color-coded spatulas at grill (red=raw, black=cooked, white=chicken/veggie/eggs)' },
        ]
      },
      {
        name: 'Third Priority - Equipment & Cleaning',
        items: [
          { id: 'st-C317', question: 'C317 - Dishwashing machines properly maintained and operated; surfaces clean; curtains clean and in place; temperatures and pressures to standard' },
          { id: 'st-C329', question: 'C329 - Wiping cloths kept clean and dry or immersed in properly diluted sanitizer. Separate cloths for food-contact and non-food surfaces. Bucket replaced every 2 hours' },
          { id: 'st-C315', question: 'C315 - All cleaning tools properly stored between uses. Sponges not used with food-contact surfaces' },
          { id: 'st-C319', question: 'C319 - Manual warewashing facilities properly maintained and operated. Wash-Rinse-Sanitize process correct' },
          { id: 'st-C321', question: 'C321 - Clean utensils, equipment and food-contact packaging stored in sanitary manner. Utensil handles all point same direction' },
          { id: 'st-C325', question: 'C325 - Nonfood-contact surfaces of equipment and utensils are properly cleaned (door handles, gaskets, tracks, shelves, racks)' },
          { id: 'st-C327', question: 'C327 - Nonfood-contact surfaces are durable, non-toxic, easily cleanable and in good condition' },
        ]
      },
      {
        name: 'Third Priority - Personal Hygiene & Behavior',
        items: [
          { id: 'st-C330', question: 'C330 - Eating, drinking and tobacco use restricted to nonfood areas. Personal items properly stored' },
          { id: 'st-C331', question: 'C331 - Good personal hygiene practices followed. Clean outer clothing. Hair and beard restraints used. Jewelry removed. No artificial nails or nail polish' },
          { id: 'st-C333', question: 'C333 - Restrooms used by food handlers maintained clean. Handwash sinks supplied. Restroom doors to food areas are self-closing' },
        ]
      },
      {
        name: 'Third Priority - Facility Structure',
        items: [
          { id: 'st-C341', question: 'C341 - Lighting adequate for cleaning and food handling. Lights shielded or shatter-proof above exposed food' },
          { id: 'st-C335', question: 'C335 - Floors, walls, and ceilings free of excessive dust, debris and standing water' },
          { id: 'st-C337', question: 'C337 - Floors, walls and ceilings smooth, easily cleanable, and in good repair' },
          { id: 'st-C339', question: 'C339 - Ventilation adequate; vents, fan guards and filters clean' },
        ]
      },
      {
        name: 'Third Priority - Pest & Garbage',
        items: [
          { id: 'st-C343', question: 'C343 - No pest entry points (gaps >0.6cm beneath exterior doors). No pest harborage sites. Wet mops hung to dry' },
          { id: 'st-C345', question: 'C345 - Pest control devices working properly and installed to not contaminate food. Catch trays and glue boards changed as necessary' },
          { id: 'st-C351', question: 'C351 - Integrated pest management program carried out by qualified pest control operator' },
          { id: 'st-C347', question: 'C347 - Interior garbage containers cleaned and emptied as needed' },
          { id: 'st-C349', question: 'C349 - Exterior garbage storage covered and doors kept closed. Containers emptied, surrounding area maintained clean' },
        ]
      },
      {
        name: 'Third Priority - A&W Specific',
        items: [
          { id: 'st-703', question: '703 - Dedicated timers available for each product (patties, chicken, fries, onion rings, grilled onions, etc.)' },
          { id: 'st-705', question: '705 - Ketchup dispenser protected from tampering (cryovac bag or stainless steel bracket)' },
          { id: 'st-707', question: '707 - Only approved box cutters in use (no exposed tips or retractable blades)' },
          { id: 'st-729', question: '729 - Manager and staff can explain proper response to a complaint of foodborne illness' },
          { id: 'st-725', question: '725 - Food Facts pamphlet available and staff know how to respond to questions' },
        ]
      },
      {
        name: 'Information Only',
        items: [
          { id: 'st-AL101', question: 'AL101 - Employees know the steps to take when a guest states they have a food allergy' },
          { id: 'st-AL103', question: 'AL103 - Manager is aware of priority allergens (can name at least 5 of 10)' },
          { id: 'st-DOC103', question: 'DOC103 - Written sanitation program is in place, monitored and recorded (digital assessments via CMX Be Clean)' },
          { id: 'st-DOC105', question: 'DOC105 - Food safety training of food handlers is conducted and recorded' },
          { id: 'st-DOC107', question: 'DOC107 - Facility is appropriately licensed/permitted to operate with permit posted in guest view' },
          { id: 'st-804', question: '804 - Chemical sanitizer solutions for manual use are in use during assessment' },
          { id: 'st-805', question: '805 - Location does not operate while Imminent Health Hazards are occurring' },
        ]
      }
    ]
  },

  'be-clean': {
    name: 'Be Clean - Monthly Cleaning & Maintenance Assessment',
    description: 'Monthly, Quarterly, Bi-Annual, and Annual cleaning and maintenance checklist - matches CMX exactly',
    sections: [
      {
        name: 'Monthly Kitchen',
        items: [
          { id: 'bc-mk1', question: 'Toaster - Clean the fan filters, bottom element reflector, touchpad control, and belt/chain' },
          { id: 'bc-mk2', question: 'Fryer - Clean behind fryer. Drain and clean fry pot, filter pan, detachable parts, and accessories. Check thermostat calibration' },
          { id: 'bc-mk3', question: 'CVAP - Check the door seals, rollers and cords. Check for descaling' },
          { id: 'bc-mk4', question: 'Thermodyne - Shut down. Remove back and side panels and check cleanliness. Check fluid level in the reservoir tank' },
          { id: 'bc-mk5', question: 'Reach-in Coolers - Clean all condenser coils and fans. Ensure proper airflow. Check cords, plugs, sockets, door hinges and seals' },
          { id: 'bc-mk6', question: 'Reach-in Freezers - Clean all condenser coils and fans. Ensure proper airflow. Check cords, plugs, sockets, door hinges, seals, and door release mechanism' },
          { id: 'bc-mk7', question: 'Walk-in Cooler - Clean all condenser coils and fans. Ensure proper airflow. Check cords, plugs, sockets, door hinges, seals, and door release mechanism' },
          { id: 'bc-mk8', question: 'Walk-in Freezer - Clean all condenser coils and fans. Ensure proper airflow' },
          { id: 'bc-mk9', question: '2 Drawer Cooler - Clean compressor. Check condition of rollers and seals on drawers. Check cords, plugs and sockets' },
          { id: 'bc-mk10', question: '2 Drawer Freezer - Clean compressor. Check condition of rollers and seals on drawers. Check cords, plugs and sockets' },
        ]
      },
      {
        name: 'Monthly Servery',
        items: [
          { id: 'bc-ms1', question: 'Fresh Blender - Review Interior Components for condition and cleanliness (drain line, blender shaft, ice machine reservoir, ice chute)' },
          { id: 'bc-ms2', question: 'Fresh Blender - Review Software is Current (includes 4 hour blender sanitize and 2 Step Clean/Sanitize Zone 2)' },
          { id: 'bc-ms3', question: 'Sureshot - Check calibration. Clean condenser, fan & inner body. Clean valve assembly & door gasket' },
          { id: 'bc-ms4', question: 'Pop Machine - Check condition of nozzles, diffusers & O rings. Check water level in bath & Clean Condenser Coil' },
          { id: 'bc-ms5', question: 'Undercounter Cooler - Clean grate and compressor. Check condition of door seal, hinges, cords' },
          { id: 'bc-ms6', question: 'Drive-Thru Window - Slides cleaned' },
        ]
      },
      {
        name: 'Monthly Dining Room',
        items: [
          { id: 'bc-md1', question: 'Tables and chairs - Check condition of welds, levels, table and chair tops' },
        ]
      },
      {
        name: 'Monthly General',
        items: [
          { id: 'bc-mg1', question: 'Roof top - Check condition of protective pads around exhaust fans, clean or replace as needed. Check grease overflow pans and empty as needed' },
          { id: 'bc-mg2', question: 'Bathrooms - Check plumbing and faucets, replacing gaskets and washers as needed. Check toilet flush mechanism' },
          { id: 'bc-mg3', question: 'Appliances - Check condition of all appliances electrical cords' },
          { id: 'bc-mg4', question: 'Floor and Ceiling Tiles - Check for condition and for any cracks' },
        ]
      },
      {
        name: 'Quarterly Servery',
        items: [
          { id: 'bc-qs1', question: 'Fresh Blender - Clean condenser grill. Clean drain pipe. Check blender shaft cycle counts - change before 36,000 cycles' },
          { id: 'bc-qs2', question: 'Fresh Blender - Descale/sanitize ice machine (Zone 3) - minimum quarterly' },
          { id: 'bc-qs3', question: 'Fresh Blender - Manual Clean of Ice Machine (Zone 4) by trained technician or local ice machine service company (photo required)' },
        ]
      },
      {
        name: 'Quarterly Kitchen',
        items: [
          { id: 'bc-qk1', question: 'Grease trap - Professional cleaning of grease traps (or as needed)' },
          { id: 'bc-qk2', question: 'HVAC - Professional inspection and cleaning of kitchen exhaust ductwork' },
        ]
      },
      {
        name: 'Quarterly General',
        items: [
          { id: 'bc-qg1', question: 'Refrigeration - Check seals on all doors. Replace as needed' },
          { id: 'bc-qg2', question: 'Roof top - Professional review of HVAC system, including replacing filters, clearing debris belts, and adjusting settings' },
          { id: 'bc-qg3', question: 'Fire suppression system - Professional inspection of fire extinguishers and hood fire suppression system' },
        ]
      },
      {
        name: 'Bi-Annually Servery',
        items: [
          { id: 'bc-ba1', question: 'Fresh Blender - Bi-Annual preventative maintenance to inspect ice maker/dispenser, check o-rings, check ice quality, full descale/sanitize/manual clean (professional servicing required, photo required)' },
        ]
      },
      {
        name: 'Annually Kitchen',
        items: [
          { id: 'bc-ak1', question: 'Clamshell Grill - Annual preventative maintenance to test for proper operation and replace wearable parts (professional servicing required)' },
          { id: 'bc-ak2', question: 'Fryer - Annual preventative maintenance to clean combustion blower build-up, ensure flue is clear, verify burners, inspect for leaks, verify temperature (professional servicing required)' },
          { id: 'bc-ak3', question: 'Thermodyne - Annual preventative maintenance to change heat transfer fluid, inspect for leaks, replace problem wires/connectors, check pump, fan blades, louvres, electrical terminals (professional servicing required)' },
          { id: 'bc-ak4', question: 'Dishwasher - Descale (in regions with hard water)' },
        ]
      },
      {
        name: 'Annually Servery',
        items: [
          { id: 'bc-as1', question: 'Franke - Annual preventative maintenance to inspect and replace wearable items related to hydraulic, brew, and milk systems (professional servicing required)' },
        ]
      },
      {
        name: 'Annually General',
        items: [
          { id: 'bc-ag1', question: 'Refrigeration - Annual preventative maintenance to check temperature, clean all condensers, check door gaskets and hinges (professional servicing recommended)' },
        ]
      }
    ]
  }
};

export const getAuditQuestions = (auditType) => {
  return AUDIT_QUESTIONS[auditType] || null;
};

export const getTotalItems = (auditType) => {
  const questions = AUDIT_QUESTIONS[auditType];
  if (!questions) return 0;
  return questions.sections.reduce((sum, s) => sum + s.items.length, 0);
};

export const calculateAuditScore = (responses, auditType) => {
  const questions = AUDIT_QUESTIONS[auditType];
  if (!questions) return { score: 0, passed: 0, total: 0, criticalFailed: false };
  
  let total = 0;
  let passed = 0;
  let naCount = 0;
  let criticalFailed = false;
  
  questions.sections.forEach(section => {
    section.items.forEach(item => {
      const response = responses[item.id];
      if (response === 'na') {
        naCount++;
      } else {
        total++;
        if (response === 'yes' || response === 'pass' || response === true) {
          passed++;
        } else if (item.critical && (response === 'no' || response === 'fail' || response === false)) {
          criticalFailed = true;
        }
      }
    });
  });
  
  // N/A items are excluded from the total count
  let score = total > 0 ? Math.round((passed / total) * 100) : 0;
  
  // If any critical item failed in Steritech, max score is 70%
  if (criticalFailed && score > 70) {
    score = 70;
  }
  
  return { score, passed, total, naCount, criticalFailed };
};
